/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseCodeInterpreterCallInProgressEvent = {
  type: "response.code_interpreter_call.in_progress";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
};

/** @internal */
export const ResponseCodeInterpreterCallInProgressEvent$inboundSchema:
  z.ZodType<ResponseCodeInterpreterCallInProgressEvent, z.ZodTypeDef, unknown> =
    z.object({
      type: z.literal("response.code_interpreter_call.in_progress"),
      sequence_number: z.number().int(),
      item_id: z.string(),
      output_index: z.number().int(),
    }).transform((v) => {
      return remap$(v, {
        "sequence_number": "sequenceNumber",
        "item_id": "itemId",
        "output_index": "outputIndex",
      });
    });
/** @internal */
export type ResponseCodeInterpreterCallInProgressEvent$Outbound = {
  type: "response.code_interpreter_call.in_progress";
  sequence_number: number;
  item_id: string;
  output_index: number;
};

/** @internal */
export const ResponseCodeInterpreterCallInProgressEvent$outboundSchema:
  z.ZodType<
    ResponseCodeInterpreterCallInProgressEvent$Outbound,
    z.ZodTypeDef,
    ResponseCodeInterpreterCallInProgressEvent
  > = z.object({
    type: z.literal("response.code_interpreter_call.in_progress"),
    sequenceNumber: z.number().int(),
    itemId: z.string(),
    outputIndex: z.number().int(),
  }).transform((v) => {
    return remap$(v, {
      sequenceNumber: "sequence_number",
      itemId: "item_id",
      outputIndex: "output_index",
    });
  });

export function responseCodeInterpreterCallInProgressEventToJSON(
  responseCodeInterpreterCallInProgressEvent:
    ResponseCodeInterpreterCallInProgressEvent,
): string {
  return JSON.stringify(
    ResponseCodeInterpreterCallInProgressEvent$outboundSchema.parse(
      responseCodeInterpreterCallInProgressEvent,
    ),
  );
}
export function responseCodeInterpreterCallInProgressEventFromJSON(
  jsonString: string,
): SafeParseResult<
  ResponseCodeInterpreterCallInProgressEvent,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseCodeInterpreterCallInProgressEvent$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ResponseCodeInterpreterCallInProgressEvent' from JSON`,
  );
}
